<template>
  <div class="app-search-results">
    <b-form  @submit="loadMoreResults" v-if="this.searchPhrase && searchResults && searchResults.length > 0">
      <h3 class="result-count">{{this.searchTotalResults}} <slot name="lblResults">Ergebnisse</slot></h3>
      <b-form-group>
      <div class="result-list-wrapper">
        <ul>
          <li v-for="(result, index) in searchResults" :key="index">
            <div class="result-item-wrapper">
                <div class="icon" v-if="result.image"><img :src="result.image" /></div>
                <div class="text" v-if="result.url">
                  <a :href="result.url" @mousedown="handleEventTracking(index, $event)">
                    {{ result.title }}
                  </a>
                  <div v-html="result.description ? result.description : result.content"></div>
              </div>
            </div>
          </li>
          <li class="more-results" v-if="hasMoreResults">
            <button class="filled yellow" aria-label="Suche" @click="loadMoreResults"><span class="button-text"><slot name="lblMoreResults">Mehr anzeigen</slot></span></button>
          </li>
        </ul>
      </div>
      </b-form-group>
    </b-form>
    <div class="no-results" v-else-if="!searchLoading">
      <slot name="txtNoResults"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import beErrors from '@/mixins/beErrors'

export default {
  name: 'SearchResults',
  data () {
    return {
      start: 0,
      rows: 6,
      debounceTimer: null
    }
  },
  created () { },
  mounted () {
    this.debounce(() => this.handlePageTracking())()
  },
  watch: {
    '$store.state.search.searchResults': function (v) {
      if (v !== null) {
        this.debounce(() => this.handlePageTracking())()
      } else {
        this.start = 0
      }
    }
  },
  computed: {
    ...mapGetters('search', [
      'searchPhrase',
      'searchResults',
      'searchTotalResults',
      'searchLoading'
    ]),
    hasMoreResults: function () {
      return this.searchTotalResults > this.start + this.rows
    }
  },
  methods: {
    ...mapActions('search', [
      'querySearch'
    ]),
    loadMoreResults (event) {
      event.preventDefault()
      this.start += this.rows
      const _this = this
      this.querySearch({ searchQuery: this.searchPhrase, start: this.start, rows: this.rows }).then((result) => {
        if (!result) {
          const message = _this.beErrorGetLastMessage()
          _this.errorToast(message)
          const data = {
            type: 'technical',
            message: message
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        }
      }).catch(() => {
        const message = _this.beErrorGetLastMessage()
        _this.errorToast(message)
        const data = {
          type: 'technical',
          message: message
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
      })
    },
    handlePageTracking () {
      if (this.searchLoading) {
        return
      }
      let trackingData = {
        login_status: 'not logged in',
        page_levels: [
          'hilfe & support',
          'suche'
        ],
        page_type: 'content',
        platform_type: 'browser view'
      }
      if (this.searchPhrase && this.searchResults !== null) {
        trackingData = {
          ...trackingData,
          search_action: 'enter',
          search_term: this.searchPhrase,
          search_nr_results: '' + this.searchTotalResults,
          search_type: 'service serp'
        }
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('pageview', trackingData)
      }
    },
    handleEventTracking (resultIndex, event) {
      const cookieData = this.searchPhrase + ':::' + (resultIndex + 1) + ':::' + this.searchResults[resultIndex].title + ':::' + this.searchTotalResults + ':::' + 'service serp'
      if (window.cookieNS && window.cookieNS.main) {
        window.cookieNS.main.setCookie('searchData', cookieData, 1)
      }
    },
    debounce (func, timeout = 1000) {
      return (...args) => {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => { func.apply(this, args) }, timeout)
      }
    }
  },
  mixins: [
    beErrors
  ],
  props: { }
}
</script>
